import { formatFontDisplayName } from './formatFontDisplayName';
import { resolveFontsFromMjml } from './resolveFontsFromMjml';
export const getMjmlFonts = (mjml, extendedList) => {
  var _resolveFontsFromMjml;
  const mjmlFonts = (_resolveFontsFromMjml = resolveFontsFromMjml(mjml)) == null ? void 0 : _resolveFontsFromMjml.map(formatFontDisplayName);
  const uniqueMjmlFonts = [...new Set(mjmlFonts)];
  const emailFontOptions = uniqueMjmlFonts.map(font => {
    const displayName = formatFontDisplayName(font);
    return {
      displayName,
      cssFontFamily: font.toLocaleLowerCase().replaceAll(', ', ',')
    };
  });
  const predefinedFonts = Object.values(extendedList).filter(font => font.supportedInHtmlEmails && !uniqueMjmlFonts.includes(font.displayName));
  return [...emailFontOptions, ...predefinedFonts].sort((a, b) => a.displayName.localeCompare(b.displayName));
};
//# sourceMappingURL=getMjmlFonts.js.map